import React, { useState, useEffect, useCallback } from 'react';
import PersonList from "../components/personList";
import Header from "../components/header";
import Filter from "../components/filter";
import './homePage.css';

function HomePage({ persons }) {
  const itemsPerPage = 3;
  const [visibleCount, setVisibleCount] = useState(itemsPerPage);
  const [filteredPersons, setFilteredPersons] = useState([]);
  const [displayPersons, setDisplayPersons] = useState([]);

  useEffect(() => {
    const initialFiltered = persons.slice(0, visibleCount);
    setFilteredPersons(persons);
    setDisplayPersons(initialFiltered);
  }, [persons, visibleCount]);

  const updateDisplayPersons = useCallback(() => {
    const newDisplayPersons = filteredPersons.slice(0, visibleCount);
    setDisplayPersons(newDisplayPersons);
  }, [filteredPersons, visibleCount]);

  useEffect(() => {
    updateDisplayPersons();
  }, [updateDisplayPersons]);

  const handleCityChange = (selectedCity) => {
    if (selectedCity === "All") {
      setFilteredPersons(persons);
    } else {
      const filtered = persons.filter(person => person.city === selectedCity);
      setFilteredPersons(filtered);
    }
    setVisibleCount(itemsPerPage);
  };

  const loadMore = () => {
    setVisibleCount(prev => prev + itemsPerPage);
  };

  return (
    <div className="homepage-container">
      <div className="header-container">
        <Header />
      </div>
      <div className="filter-container">
        <Filter handleCityChange={handleCityChange} />
      </div>
      <div className="person-list-container">
        <PersonList persons={displayPersons} />
      </div>
      {displayPersons.length < filteredPersons.length && (
        <button onClick={loadMore} className="load-more-button">Load More</button>
      )}
    </div>
  );
}

export default HomePage;
